var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseService } from "./baseService";
import { prepareParams } from "./baseService";
class MasqueradeService extends BaseService {
    constructor() {
        super(...arguments);
        this.controllerName = "auth";
    }
    changeCredentials(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = prepareParams(options);
            this.api.defaults.headers = this.getDefaultHeaders();
            const { data } = yield this.api.get(`/${this.controllerName}/masquerade`, { params });
            return data;
        });
    }
}
export const masqueradeService = new MasqueradeService();
//# sourceMappingURL=masqueradeService.js.map